'use strict';

import ModalView from '../../js/components/ModalView';
import weChatModalTemplate from './templates/_Footer-weChatModal.hbs';

const FooterModal = ModalView.extend({
  template: weChatModalTemplate,
  events: { },
  initialize() {
    FooterModal.__super__.initialize.apply(this, arguments);
  }
});

export default FooterModal;



// WEBPACK FOOTER //
// ./assets/components/Footer/_Footer-weChatModal.js